import React, { PureComponent } from "react";
// import { connect } from "react-redux";
import Navbar from "./Navbar";
import "./Navbar.scss";
// import { setWordCloudModalShow, fetchWordCloudData, excludeWords, setWordCloudType } from "../../actions/wordCloudAction";
// import { getTeamsIBelongTo } from "../../actions/rawDataAction";
// import WordCloudModal from "./WordCloudModal/WordCloudModal";
import SocialInfoModal from "../MainContent/RawData/SocialInfoModal/SocialInfoModal";

class NavbarContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showSocialModal: false,
        };
    }

    toggleSocialInfoModal(value) {
        this.setState({ showSocialModal: value });
    }

    render() {
        return (
            <>
                <Navbar
                    location={this.props.location?.pathname || location.pathname}
                    googleTranslate={this.props.googleTranslate}
                    pageTitle={this.props.pageTitle}
                    pageInfoText={this.props.pageInfoText}
                    createDashboard={this.props.createDashboard}
                    icon={this.props.icon}
                    tourComponent={this.props.tourComponent}
                    history={this.props.history}
                />

                {/* <WordCloudModal
                    open={this.props.showWordCloudModal}
                    data={this.props.wordCloudData}
                    closeModal={() => this.props.setWordCloudModalShow(false)}
                    formattedFilters={() => this.formattedFilters()}
                    fetchWordCloudData={(filter, type) => this.props.fetchWordCloudData(filter, type)}
                    dataFetching={this.props.wordCloudDataFetching}
                    dataFetched={this.props.wordCloudDataFetched}
                    excludeWords={(words) => this.props.excludeWords(words)}
                    wordcloudType={this.props.wordcloudType}
                    appliedFilter={this.props.appliedFilter}
                    setWordCloudType={(val) => this.props.setWordCloudType(val)}
                    sampling={this.props.sampling}
                /> */}
                <SocialInfoModal open={this.state.showSocialModal} toggleSocialInfoModal={this.toggleSocialInfoModal.bind(this)} />
            </>
        );
    }
}

// const mapStateToProps = (state) => {
// return {
// company: state.globalReducer.company,
// showWordCloudModal: state.wordCloudReducer.showModal,
// wordCloudData: state.wordCloudReducer.data,
// wordCloudDataFetching: state.wordCloudReducer.dataLoading,
// wordCloudDataFetched: state.wordCloudReducer.dataFetched,
// createSparkModalOpen: state.rawDataReducer.createSparkModalOpen,
// teamsIBelongToOptions: state.rawDataReducer.teamsIBelongToOptions,
// appliedFilter: state.globalReducer.appliedFilter,
// wordcloudType: state.wordCloudReducer.wordcloudType,
// };
// };

// const mapDispatchToProps = (dispatch) => {
//     return {
//         // setWordCloudModalShow: (show) => dispatch(setWordCloudModalShow(show)),
//         // setWordCloudType: (val) => dispatch(setWordCloudType(val)),
//         // fetchWordCloudData: (filters, type) => dispatch(fetchWordCloudData(filters, type)),
//         // excludeWords: (words) => dispatch(excludeWords(words)),
//         // getTeamsIBelongTo: () => dispatch(getTeamsIBelongTo()),
//     };
// };

export default NavbarContainer;
